/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState ,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AnimatedButton from '../../../components/Animation/AnimatedButton';
import { useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { Link } from 'react-router-dom';
import GlobalContext from '../../../components/Context/GloablContext';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import FilterBtn from './Filter';
import ObserverExport from '../ObserverExport';
import { popFromSubDivArray } from '../../ManageAdminAndCoporateUser/subdivisionSlice';
import HelpGuideModal from '../../../components/HelpGuideModal';
import {useGetHelpGuideAdminQuery} from '../../../features/patientSlice'
import { handleSidebarPrvState } from '../../../redux/systemConfigSlice';

const TopBarIndividual = ({
    title,
    path,
    pathPlaceholder,
    SearchInput,
    AddButton,
    menuBar,
    handleApplyFilter,
    buttonName,
    ApplyFilter,
    suggestions,
    setSuggestions,
    optimizedFn,
    setFilterValues,
    filterValues,
    initialState,
    setMultiDelete,
    SearchPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    toAddScreen,
    isExport,
    handleCheckboxChange,
    setConfirmationState,
    data,
    exportObservers,
    isIdexport,
    selectedOrganizationName,
    setSelectedOrganizationName,
    setSubDivisionDataLoading,
    userArr,
    subDivisionDataLoading
}) => {
    const { setToastmessage, Toastmessage, toastErrorMessage, setToastErrorMessage, isSideBar,setIsSideBar,setIsAdvancedSearchOpen,isAdvancedSearchOpen } = useContext(GlobalContext);
    const navigate = useNavigate()
    const fileInputRef = useRef(null);
    const dispatch = useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const [isChangeStatusOPenxl, setIsChangeStatusOpenxl] = useState(false)
    const [dateError, setdateError] = useState(false)
    const [isHover, setIsHover] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const filtervals = useSelector(state => state?.systemConfigData?.filterState)
    const ref = useRef()
    const ref2 = useRef()
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
    
    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-list-observers');
        } else {
            setQueryParamsadmin('type=admin-list-observers');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
        
    const [deleteLoading, setDeleteLoading] = useState(false)
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })

    function generateArray(params, object) {
        const result = {};
        if(searchParams?.get('organization_id')===null){
            setSelectedOrganizationName([{
                organization_name:'',
                organization_id:''
            }])
        }
        if(searchParams?.get('subdivision_ids')===null){
            dispatch(popFromSubDivArray('clearall'))
        }
        const keysToCheck = ['start_date', 'end_date', 'organization_id', 'subdivision_ids', 'status'];
        for (const key of keysToCheck) {
            if (params[key] && key !== 'start_date' && key !== 'end_date') {
                const values = params[key].split(',');
                if (key === 'organization_id') {
                    result[key] = filtervals['organization_id'];
                    result['organization_name'] = filtervals['organization_name'];
                } else {
                    result[key] = values;
                }
            } else if (Object.keys(filtervals).length !== 0 && object?.hasOwnProperty(key) && params[key]) {
                result[key] = filtervals[key];
            }
        }

        return result;
    }
    function getSearchParams() {
        const searchParams = new URLSearchParams(window.location.search);
        const result = {};

        searchParams.forEach((value, key) => {
            result[key] = value;
        });

        return result;
    }
    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })

    useOnClickOutside(ref2, () => {
        setIsChangeStatusOpenxl(false)
    })

    const handleOpenFilter = () => {
        setdateError(false)
        const params = getSearchParams()
        const resultArray = generateArray(params, filterValues);
        setSelectedOrganizationName([{
            organization_name:resultArray?.organization_name,
            organization_id:resultArray?.organization_id
        }])
        setFilterValues(resultArray)
        //dispatch(handleAddFilterValues(resultArray))
        setIsFilterOpen(!isFilterOpen)
    }

    function handleActivateClick(status) {
        if (selectedRows.map((item) => item.name).length > 50) {
            setToastErrorMessage(`You cannot ${status} more than 50 users at once`)
            setIsChangeStatusOpen(false)
            return
        }
        setIsChangeStatusOpen(false)
        if (status === "activate") {
            setConfirmationState((prev) => ({ ...prev, isOpen: selectedRows.map((item) => item.name).length > 50 ? false : true, multirow: 'active', rowData: "", user_names: selectedRows.map((item) => item.name) }))
        }
        else {
            setConfirmationState((prev) => ({ ...prev, isOpen: selectedRows.map((item) => item.name).length > 50 ? false : true, multirow: 'deactive', rowData: "", user_names: selectedRows.map((item) => item.name) }))
        }
    }

    // Function to handle onClick logic
    const handleSearchClick = () => {  
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
      
        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };

    return (
        <div className="flex justify-between xl:items-center mb-[14px]">
            <div className='flex items-center'>
                {title !== undefined ?
                    <h1 className="text-xl font-normal text-[#000000] min-w-max">{title}</h1>
                    :
                    pathPlaceholder &&
                    <Link to={path} state={username && path !== '/manage-admin-corporate/' ? [username] : null} className='hidden items-center min-w-max xl:flex'>
                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                        <span className='text-sm font-normal text-[#008586] ml-3'>{pathPlaceholder}</span>
                    </Link>
                }
                {
                    userType !=='super-admin' &&
                    <span   onClick={() => setHelpGuideModel(true)} className='ml-2 min-w-fit cursor-pointer'>
                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                    </span> 
                }

            </div>
        
            <div className="flex items-center w-fit justify-end relative 2xl:flex-nowrap flex-wrap">
                <div className='xl:block hidden'>
                    {menuBar && <div className='relative 2xl:mb-0 mb-2.5'>
                        <button id="threedot" className={`rounded-[15px] border border-[#972E4C] px-[13px] py-[10px] hover:bg-[#972E4C] focus:bg-[#972E4C] ${isChangeStatusOPen ? 'bg-[#972E4C]' : 'bg[#1111]'}`}
                            onClick={() => { setIsChangeStatusOpen(!isChangeStatusOPen),setIsFilterOpen!==undefined&&setIsFilterOpen(false) }}
                            onMouseEnter={() => setIsHover(true)}
                            onMouseLeave={() => setIsHover(false)}
                        >
                            {
                                isHover || isChangeStatusOPen ? <img src="/images/3dots_white.svg" alt="img" /> : <img src="/images/3_dots_color.svg" alt="img" />

                            }
                        </button>
                        {isChangeStatusOPen && <ul ref={ref} className='px-1.5 py-3 rounded-[6px] absolute top-12 right-5 bg-[#fff] min-w-[202px] shadow-s3 z-[2] '>
                            <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Change Status</li>
                            <li>
                                <ul>
                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => { handleActivateClick("activate") }}
                                            buttonName={"Activate"}
                                            disabled={(selectedRows?.filter((user) => user.status === 'inactive'))?.map((item) => item.name).length === 0 ? true : false}
                                            className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user) => user.status === 'inactive'))?.map((item) => item.name).length === 0 ? 'text-[#6e6d6d]' : 'hover:text-[#008586] text-[#000000] cursor-pointer'} `}
                                        />
                                    </li>
                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => { handleActivateClick("deactivate") }}
                                            buttonName={"Deactivate"}
                                            disabled={(selectedRows?.filter((user) => user.status === 'active'))?.map((item) => item.name).length === 0 ? true : false}
                                            className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user) => user.status === 'active'))?.map((item) => item.name).length === 0 ? 'text-[#706a6a]' : 'hover:text-[#008586] text-[#000000] cursor-pointer'}  `}
                                        />
                                    </li>
                                </ul>
                            </li>
                            <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Delete Observers</li>
                            <li>
                                <ul>
                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => {setMultiDelete(true) ,setIsChangeStatusOpen(false)}}
                                            buttonName={"Delete"}
                                            datatestid="delete-observer"
                                            disabled={deleteLoading}
                                            className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal   hover:text-[#6e6d6d] text-[#000000] cursor-pointer'} `} />
                                    </li>
                                </ul>
                            </li>
                        </ul>}
                    </div>}
                </div>
                {SearchInput && <button id='search-btn' onClick={handleSearchClick} className="ml-2.5 2xl:mb-0 mb-2.5 border border-[#972E4C] rounded-[15px] px-[13px] py-[13px]">
                    <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                </button>}
                <div className='flex items-center'>
                    <div className='xl:hidden block'>
                        {menuBar && <div className='relative 2xl:mb-0 mb-2.5 ml-2.5'>
                            <button id="threedot" className={`rounded-[15px] border border-[#972E4C] px-[13px] py-[10px] hover:bg-[#972E4C] focus:bg-[#972E4C] ${isChangeStatusOPenxl ? 'bg-[#972E4C]' : 'bg[#1111]'}`}
                                onClick={() => { setIsChangeStatusOpenxl(!isChangeStatusOPenxl) }}
                                onMouseEnter={() => setIsHover(true)}
                                onMouseLeave={() => setIsHover(false)}
                            >
                                {
                                    isHover || isChangeStatusOPenxl ? <img src="/images/3dots_white.svg" alt="img" /> : <img src="/images/3_dots_color.svg" alt="img" />

                                }
                            </button>
                            {isChangeStatusOPenxl && <ul ref={ref2} className='px-1.5 py-3 rounded-[6px] absolute top-12 right-5 bg-[#fff] min-w-[202px] shadow-s3 z-[2] '>
                                <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Change Status</li>
                                <li>
                                    <ul>
                                        <li>
                                            <AnimatedButton
                                                handleClick={(e) => { handleActivateClick("activate") }}
                                                buttonName={"Activate"}
                                                disabled={(selectedRows?.filter((user) => user.status === 'inactive'))?.map((item) => item.name).length === 0 ? true : false}
                                                className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user) => user.status === 'inactive'))?.map((item) => item.name).length === 0 ? 'text-[#6e6d6d]' : 'hover:text-[#008586] text-[#000000] cursor-pointer'} `}
                                            />
                                        </li>
                                        <li>
                                            <AnimatedButton
                                                handleClick={(e) => { handleActivateClick("deactivate") }}
                                                buttonName={"Deactivate"}
                                                disabled={(selectedRows?.filter((user) => user.status === 'active'))?.map((item) => item.name).length === 0 ? true : false}
                                                className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user) => user.status === 'active'))?.map((item) => item.name).length === 0 ? 'text-[#706a6a]' : 'hover:text-[#008586] text-[#000000] cursor-pointer'}  `}
                                            />
                                        </li>
                                    </ul>
                                    <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Delete Observers</li>
                                    <li>
                                        <ul>
                                            <li>
                                                <AnimatedButton
                                                    handleClick={(e) => {setMultiDelete(true) ,setIsChangeStatusOpen(false)}}
                                                    buttonName={"Delete"}
                                                    datatestid="delete-observer"
                                                    disabled={deleteLoading}
                                                    className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal   hover:text-[#6e6d6d] text-[#000000] cursor-pointer'} `} />
                                            </li>
                                        </ul>
                                    </li>
                                </li>
                            </ul>}
                        </div>}
                    </div>
                    {(ApplyFilter !== undefined && ApplyFilter) &&
                        <FilterBtn
                            dateError={dateError}
                            setdateError={setdateError}
                            isFilterOpen={isFilterOpen}
                            setIsFilterOpen={setIsFilterOpen}
                            handleApplyFilter={handleApplyFilter}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            initialState={initialState}
                            handleOpenFilter={handleOpenFilter}
                            selectedOrganizationName={selectedOrganizationName}
                            setSelectedOrganizationName={setSelectedOrganizationName}
                            setSubDivisionDataLoading={setSubDivisionDataLoading}
                            subDivisionDataLoading={subDivisionDataLoading}
                            userArr={userArr}
                        />
                    }
                    {(SearchInput || isExport) && data !== undefined && data?.data?.length > 0 && <div className='2xl:mb-0 mb-2.5'>  <ObserverExport
                        selectedRows={selectedRows}
                        exportObservers={exportObservers}
                        exportCols={exportCols}
                        setIsFilterOpen={setIsFilterOpen}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        isIdexport={isIdexport} username={username} />
                    </div>}
                    {isExport &&
                        <>{<Link to={''}>
                            <button type='button'
                                id="view_export_history"
                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] 2xl:mb-0 mb-2.5`}>
                                View Export History
                            </button>
                        </Link>}</>}
                    {AddButton &&
                        <>{<Link to={toAddScreen} state={{ "limit": searchParams.get("limit"), "page_number": searchParams.get("page_number"), "search_mode": searchParams.get("search_mode"), 'search': searchParams.get("search") ? searchParams.get("search") : '' }}>
                            <button type='button'
                                id="Add user"
                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] 2xl:mb-0 mb-2.5`} style={{ 'width': 'max-content' }}>
                                <span className="mr-2.5"><img src="/images/add_Icon_white.svg" alt="img" /></span>
                                <span>{buttonName}</span>
                            </button>
                        </Link>}</>}
                    {(helpGuideModel && helpguidestatus==="fulfilled") &&
                        <HelpGuideModal
                            setHelpGuideModel={setHelpGuideModel}
                            pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                        />
                    }
                </div>
            </div>
        </div>
    );
}

export default TopBarIndividual;
